import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  List,
  ListItem,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import Iconify from '../../../components/iconify';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useBoolean } from '../../../hooks/use-boolean';
import usePopover from '../../../hooks/use-popover';
import { toast } from 'react-toastify';

import {
  CommentDialog,
  ConfirmDialog,
  StatusDialog,
} from '../../../components/custom-dialog';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import HttpService from '../../../hooks/Https-services';
import {
  API_ROUTES,
  dateFormat,
  hasRole,
  PERIOD_STATUS,
  permissions,
  ROLE_IDS,
  timeFormat,
  UserPermissions,
} from '../../../utils/constant';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GetAppIcon from '@mui/icons-material/GetApp';
import ChecklistIcon from '@mui/icons-material/Checklist';
import Papa from 'papaparse';
import moment from 'moment';
import { GlobalSearchContext } from '../../../context/GlobalSearchContext';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import RefreshIcon from '@mui/icons-material/Refresh';
import useCommonDetails from '../../../hooks/useCommonDetails';
import { useDropzone } from 'react-dropzone';
import CommentBox from '../CommentBox';
interface Comment {
  role: string;
  name: string;
  comment: string;
  addedAt: string; // or Date if you prefer
}
function PeriodRow(props: {
  period: any;
  currentUserInfo: any;
  userInfo: any;
  handleApiToggle: any;
  fetchGamesList: any;
  gameData?: any;
  isPeriodOnly: boolean;
}) {
  const {
    period,
    currentUserInfo,
    userInfo,
    handleApiToggle,
    gameData,
    fetchGamesList,
    isPeriodOnly,
  } = props;
  const [optionsTagger, setOptionsTagger] = useState<
    { label: string; id: number; middleName: string }[]
  >([]);
  const {
    handleSearchChangeTag,
    debouncedQueryTag,
    _searchQueryTag,
    fatchCurrentTaggingRequest,
  }: any = useContext(GlobalSearchContext);

  const details = useCommonDetails();
  const [commentText, setCommentText] = React.useState('');
  const commentView = useBoolean();
  const popover = usePopover();
  const confirm = useBoolean();
  const uplaodFile = useBoolean();
  const viewFile = useBoolean();
  const [elapsedTime, setElapsedTime] = useState<number>(
    period?.elapsedTime || 0
  );
  const [totalElapsedTime, setTotalElapsedTime] = useState<number>(
    period?.elapsedTime || 0
  );
  const [isRunning, setIsRunning] = useState(period?.isRunning || false);
  const [startTime, setStartTime] = useState<Date | null>(
    period?.startTime ? new Date(period?.startTime) : null
  );

  const [tabIndex, setTabIndex] = useState(0); // State to manage the active tab
  const [expandedRows, setExpandedRows] = useState<any>({}); // State for expandable rows
  const [viewFileData, setViewFileData] = useState<any>([]);
  const [isLoadingShiftFile, setIsLoadingShiftFile] = useState(false);
  const [isLoadingEventFile, setIsLoadingEventFile] = useState(false);
  const [isLoadingCompleteStatus, setIsLoadingCompleteStatus] = useState(false);
  const [loadingProgress, setLoadingProgress] = React.useState(false);
  const [value, setValue] = useState<any>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [period.id]);
  useEffect(() => {
    const optdata = userInfo?.map((el: any) => {
      return {
        label: el.name,
        id: el.id,
        middleName: el.middleName,
      };
    });
    setOptionsTagger(optdata);
  }, [userInfo]);
  useEffect(() => {
    if (period?.assignUser) {
      setValue({
        label: period?.assignUser?.name,
        id: period?.assignUser?.id,
        middleName: period?.assignUser?.middleName,
      });
    }
  }, [period?.assignUser]);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        const now = moment().valueOf(); // Current time in milliseconds
        const start = moment(startTime).valueOf(); // Start time in milliseconds
        const currentElapsedTime = (now - start) / 1000 + totalElapsedTime;
        setElapsedTime(currentElapsedTime);
      }, 1000);
    } else if (!isRunning && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isRunning, totalElapsedTime, elapsedTime, period]);

  const handleStart = async () => {
    try {
      // Get the document reference using the modular syntax
      const dataCall = await HttpService.get(
        `${API_ROUTES.PeriodList}?periodId=${period.id}`
      );

      const oldData = dataCall.data.data.list[0];

      if (oldData) {
        setTotalElapsedTime(oldData?.elapsedTime || 0);
        setElapsedTime(oldData?.elapsedTime || 0);
        setIsRunning(true);

        const newStartTime = moment().toDate();
        setStartTime(newStartTime);

        // Update the document using the modular SDK
        const updateData = {
          isRunning: true,
          showInfo: true,
          isTimeTrackerOn: true,
        };
        const response = await HttpService.patch(
          `${API_ROUTES.updatePeriodList}/${period.id}`,
          updateData
        );
      }
      handleApiToggle(period.gameId);
    } catch (error) {
      console.error('Error fetching elapsed time:', error);
    }
  };

  const handleStop = async () => {
    setIsRunning(false);
    const now = new Date();

    if (isRunning) {
      // const start = moment(startTime).valueOf();
      // const stoppedElapsedTime = (moment().valueOf() - start) / 1000;
      // const newTotalElapsedTime = totalElapsedTime + stoppedElapsedTime;

      // setTotalElapsedTime(newTotalElapsedTime);
      // setElapsedTime(newTotalElapsedTime);
      // setStartTime(null);

      try {
        // Update the document with the new values
        const data = {
          // elapsedTime: newTotalElapsedTime,
          isRunning: false,
          timerStoped: true,
          applyForReview: true,
          showInfo: false,
        };

        const response = await HttpService.patch(
          `${API_ROUTES.updatePeriodList}/${period.id}`,
          data
        );
        // handleApiToggle(period.gameId);
      } catch (error) {
        console.error('Error updating elapsed time and active days:', error);
      }
    }
  };
  const formatElapsedTime = (elapsedTimes: number) => {
    const days = Math.floor(elapsedTimes / (3600 * 24));
    const hours = Math.floor((elapsedTimes % (3600 * 24)) / 3600);
    const minutes = Math.floor((elapsedTimes % 3600) / 60);
    const seconds = Math.floor(elapsedTimes % 60);

    const daysStr = days > 0 ? `${days}d ` : '';
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');

    return `${daysStr}${hoursStr}:${minutesStr}:${secondsStr}`;
  };

  const addComment = async (rowId: string) => {
    if (!commentText.trim()) {
      console.warn('Comment cannot be empty.');
      return;
    }

    const newComment: Comment = {
      role: currentUserInfo.roleId || 'admin',
      name: currentUserInfo.name,
      comment: commentText,
      addedAt: new Date().toISOString(),
    };

    try {
      const existingComments: Comment[] = period?.comment || [];
      const updatedComments = [...existingComments, newComment];

      const data = {
        comment: updatedComments,
      };
      const response = await HttpService.patch(
        `${API_ROUTES.updatePeriodList}/${rowId}`,
        data
      );

      setCommentText(''); // Reset comment text
      handleApiToggle(period.gameId);
      toast.success('Comment Add Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.error('Error updating comments:', error);
    }
  };

  const assignChange = async (newValue: any, id: string, gameId: string) => {
    const selectedValue = newValue.id; // Safe check for value
    if (!selectedValue) {
      console.error('Error: selected value is undefined');
      toast.error('No user selected', {
        position: 'bottom-right',
      });
      return;
    }

    try {
      // Update the document with the updated assing array
      const data = {
        assignId: selectedValue,
        periodId: id,
      };
      const response = await HttpService.post(API_ROUTES.assignTagger, data);
      handleApiToggle(gameId);
      toast.success('Assigned User Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.error('Error updating assignment: ', error);
    }
  };

  const updateReviewRate = async (event: any, id: string, gameId: string) => {
    try {
      const currentReviewRate = period ? period.reviewRate || [] : [];

      // Append the new reviewRate to the existing array
      const updatedReviewRate = [
        ...currentReviewRate, // Keep previous values
        {
          reviewRate: event.target.value,
          reviewAt: new Date().toISOString(),
          userId: currentUserInfo.userId,
        },
      ];

      // Update the document with the updated reviewRate array
      const data = {
        reviewRate: updatedReviewRate,
        statusTms: 'IN_PROGRESS',
      };
      const response = await HttpService.patch(
        `${API_ROUTES.updatePeriodList}/${id}`,
        data
      );

      handleApiToggle(gameId);
      toast.success('Review Added Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.error('Error Review Rate: ', error);
    }
  };

  const updateStatus = async (event: any, id: string, gameId: string) => {
    try {
      const data = {
        new_value: event.target.value,
        old_value: period?.statusTms,
        periodId: period.id,
        reason: 'MANUAL',
      };

      const response = await HttpService.patch(
        API_ROUTES.updatePeriodStatus,
        data
      );
      fetchGamesList();
      handleApiToggle(gameId);
      toast.success('Status Upadated Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.error('Error updating status: ', error);
    }
  };

  const updatePeriod = async (event: any, id: string) => {
    try {
      const data = {
        periodNo: event.target.value,
      };
      const response = await HttpService.patch(
        `${API_ROUTES.updatePeriodList}/${id}`,
        data
      );

      handleApiToggle(period.gameId);
      toast.success('Period Added Successfully', {
        position: 'bottom-right',
      });
    } catch (error) {
      console.log(error);
    }
  };

  const ChangeStatus = async (id: any, gameId: any) => {
    setIsLoadingCompleteStatus(true);
    try {
      const data = {
        new_value: 'TAGGING_COMPLETED',
        old_value: period?.statusTms,
        periodId: period.id,
        reason: 'MANUAL',
      };
      period?.isRunning && handleStop();
      const response = await HttpService.patch(
        API_ROUTES.updatePeriodStatus,
        data
      );
      fetchGamesList();
      handleApiToggle(gameId);
      fatchCurrentTaggingRequest();
      toast.success('Status Upadated Successfully', {
        position: 'bottom-right',
      });
      setIsLoadingCompleteStatus(false);
    } catch (error: any) {
      console.error('Error updating status: ', error);
      setIsLoadingCompleteStatus(false);
    }
  };

  // Handle shift file selection
  const handleShiftFileUpload = async (acceptedFiles: File) => {
    setIsLoadingShiftFile(true);
    try {
      if (acceptedFiles) {
        // Assuming only one file is uploaded, use the first file
        const file = acceptedFiles;

        // Check if a document with periodId and type: 1 exists
        const querySnapshot = await HttpService.get(
          `${API_ROUTES.documentList}?type=${1}&periodId=${period.token}`
        );

        const fileData = querySnapshot.data.data.periods[0];
        if (querySnapshot.data.data.periods.length > 0) {
          const updateData = {
            Key: fileData.keyName,
            FileType: fileData.fileType,
          };

          const formData = new FormData();
          formData.append('file', file);
          formData.append('data', JSON.stringify(updateData));

          const response = await HttpService.post(
            `${API_ROUTES.updateFile}`,
            formData
          );

          // Append new file details to existing files
          const existingData = fileData;
          const updatedFiles = [
            ...(existingData.files || []),
            {
              ...response.data,
              createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
              userId: details.userId,
            },
          ];

          // Update the document
          const data = {
            files: updatedFiles,
            updatedAt: new Date(),
          };
          const id = fileData.id;
          await HttpService.patch(`${API_ROUTES.documentAdd}/${id}`, data);

          toast.success('Shift file updated successfully.', {
            position: 'bottom-right',
          });
        } else {
          const formData = new FormData();
          formData.append('file', file);

          const response = await HttpService.post(
            `${API_ROUTES.uploadFile}`,
            formData
          );

          // Create a new document
          const newFileData = {
            periodId: period.token,
            gameId: period.gameId,
            userId: currentUserInfo?.userId,
            updatedAt: new Date(),
            type: 1,
            keyName: response.data.Key,
            fileType: response.data.FileType,
            files: [
              {
                ...response.data,
                userId: details.userId,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
              },
            ],
          };

          await HttpService.post(`${API_ROUTES.documentAdd}`, newFileData);

          toast.success('Shift file uploaded successfully.', {
            position: 'bottom-right',
          });
        }

        fetchGamesList();
        handleApiToggle(period.gameId);
        fetchDocumentsByPeriodAndType();
        popover.onClose();
      } else {
        toast.error('No files received for upload.', {
          position: 'bottom-right',
        });
      }
    } catch (error: any) {
      console.error('Error uploading shift file:', error);
      toast.error('Shift file upload failed.', {
        position: 'bottom-right',
      });
    } finally {
      setIsLoadingShiftFile(false);
    }
  };

  // Handle event file selection
  const handleEventFileUpload = async (acceptedFiles: File) => {
    setIsLoadingEventFile(true);

    try {
      if (acceptedFiles) {
        // Use the first file from the accepted files
        const file = acceptedFiles;

        // Check if a document with periodId and type: 2 exists
        const querySnapshot = await HttpService.get(
          `${API_ROUTES.documentList}?type=2&periodId=${period.token}`
        );

        const fileData = querySnapshot.data.data.periods[0];

        if (querySnapshot.data.data.periods.length > 0) {
          const updateData = {
            Key: fileData.keyName,
            FileType: fileData.fileType,
          };

          const formData = new FormData();
          formData.append('file', file);
          formData.append('data', JSON.stringify(updateData));

          const response = await HttpService.post(
            `${API_ROUTES.updateFile}`,
            formData
          );

          // Append new file details to existing files
          const existingData = fileData;
          const updatedFiles = [
            ...(existingData.files || []),
            {
              ...response.data,
              userId: details.userId,
              createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            },
          ];

          // Update the document
          const data = {
            files: updatedFiles,
            updatedAt: new Date(), // Update the timestamp
          };
          const id = fileData.id;
          await HttpService.patch(`${API_ROUTES.documentAdd}/${id}`, data);

          toast.success('Event file updated successfully.', {
            position: 'bottom-right',
          });
        } else {
          const formData = new FormData();
          formData.append('file', file);

          const response = await HttpService.post(
            `${API_ROUTES.uploadFile}`,
            formData
          );

          // Create a new document
          const newFileData = {
            periodId: period.token,
            gameId: period.gameId,
            userId: currentUserInfo?.userId,
            updatedAt: new Date(),
            type: 2,
            keyName: response.data.Key,
            fileType: response.data.FileType,
            files: [
              {
                ...response.data,
                userId: details.userId,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
              },
            ],
          };

          await HttpService.post(`${API_ROUTES.documentAdd}`, newFileData);

          toast.success('Event file uploaded successfully.', {
            position: 'bottom-right',
          });
        }

        // Fetch updated data
        fetchGamesList();
        handleApiToggle(period.gameId);
        fetchDocumentsByPeriodAndType();
        popover.onClose();
      } else {
        toast.error('No files received for upload.', {
          position: 'bottom-right',
        });
      }
    } catch (error: any) {
      console.error('Error uploading event file:', error);
      toast.error('Event file upload failed.', {
        position: 'bottom-right',
      });
    } finally {
      setIsLoadingEventFile(false);
    }
  };

  const fetchDocumentsByPeriodAndType = useCallback(async () => {
    try {
      // Create a reference to the 'document' collection
      if (viewFile.value) {
        const querySnapshot = await HttpService.get(
          `${API_ROUTES.documentList}?type=${tabIndex === 0 ? 1 : 2}&periodId=${period.token}`
        );
        // Map through the documents to get the data
        setViewFileData(querySnapshot.data.data.periods);
      }
    } catch (error) {
      console.error('Error fetching documents: ', error);
      throw error; // Throw error for handling in the caller function if necessary
    }
  }, [tabIndex, viewFile.value, period.token]);
  useEffect(() => {
    fetchDocumentsByPeriodAndType();
  }, [fetchDocumentsByPeriodAndType]);

  const handleTabChange = (event: any, newValue: any) => {
    setTabIndex(newValue); // Update the active tab
  };

  const handleRowToggle = (id: any) => {
    setExpandedRows((prev: any) => ({
      ...prev,
      [id]: !prev[id], // Use id for toggling
    }));
  };

  const getBackgroundColor = (role: any) => {
    switch (role) {
      case 3:
        return '#C4CDD5';
      case 1:
        return '#9CDBA6';
      case 2:
        return '#FEEFAD';
      default:
        return '#F4F6F8'; // Replace with your default color
    }
  };

  const handleCheckDisable = (
    currentStatus: string,
    status: string,
    role: string
  ) => {
    // If the current status is 'FINISHED' and the user is an admin, all options are enabled
    if (
      currentStatus == 'FINISHED' &&
      hasRole(currentUserInfo.roleId, [ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN])
    ) {
      return false; // Enable all items for admins in FINISHED status
    }

    // For non-admin users or other statuses, apply the regular logic
    switch (currentStatus) {
      case 'UNASSIGNED':
        return true; // All are disabled
      case 'ASSIGNED':
        return status !== 'READY_FOR_TAGGING'; // Only READY_FOR_TAGGING is enabled
      case 'READY_FOR_TAGGING':
        return !['IN_PROGRESS', 'CORRECTION', 'TAGGING_COMPLETED'].includes(
          status
        ); // Only IN_PROGRESS, CORRECTION, TAGGING_COMPLETED are enabled
      case 'CORRECTION':
      case 'IN_PROGRESS':
        return status !== 'TAGGING_COMPLETED'; // Only TAGGING_COMPLETED is enabled
      case 'TAGGING_COMPLETED':
        return !['FINISHED', 'CORRECTION'].includes(status); // Only MANUAL_QC_COMPLETED, FINISHED are enabled
      case 'FINISHED':
        return true; // All are disabled for non-admins in FINISHED status
      default:
        return false; // Default: all enabled
    }
  };

  const handleClickProgress = async () => {
    try {
      setLoadingProgress(true);
      const response = await HttpService.post(
        API_ROUTES.progressPeriod + `/${period.token}`
      );
      handleApiToggle(period.gameId);
      setLoadingProgress(response.data.data.totalPages);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoadingProgress(false);
    }
  };
  const isAssignedWithinLast120Minutes = (assignedAt: any) => {
    if (!assignedAt) return false;
    if (period?.assign != details.userId) return false;
    const assignedDate: any = moment(assignedAt).valueOf();
    const now: any = moment().valueOf();
    const differenceInMilliseconds = now - assignedDate;
    const differenceInMinutes = differenceInMilliseconds / 1000 / 60;
    return differenceInMinutes <= 30;
  };

  interface ValidationResult {
    rowNumber: number;
    row: string[];
  }

  interface FileValidationResults {
    validRows: ValidationResult[];
    invalidRows: ValidationResult[];
  }

  const validateShiftRow = (row: string[]): boolean => {
    // Ensure the row starts with "HOME" or "AWAY" and subsequent columns are either numeric or time values
    if (!row || row.length === 0) return false;

    const [first, ...rest] = row;
    const isValidStart = /^(HOME|AWAY)$/.test(first);
    const isValidTimeOrNumber = rest.every((value) => {
      // Check if the value is numeric or a valid time format
      return (
        /^\d+$/.test(value.trim()) ||
        /^(\d{2}:\d{2}:\d{2}(\.\d{1,3})?)$/.test(value.trim())
      );
    });

    return isValidStart && isValidTimeOrNumber;
  };

  const validateEventRow = (row: string[]): boolean => {
    // Ensure the row starts with "HOME" or "AWAY" and subsequent columns have text (not just numbers)
    if (!row || row.length === 0) return false;

    const [first, ...rest] = row;
    const isValidStart = /^(HOME|AWAY|NONE)$/.test(first);
    const hasText = rest.some((value) => /[a-zA-Z]/.test(value.trim())); // Ensure at least one value has text

    return isValidStart && hasText;
  };

  const handleFileUpload = async (file: File, fileType: 'shift' | 'event') => {
    Papa.parse(file, {
      complete: (result: any) => {
        const data = result.data as string[][];

        const validRows: ValidationResult[] = [];
        const invalidRows: ValidationResult[] = [];

        // Filter out any empty or whitespace-only rows
        const filteredData = data.filter((row) =>
          row.some((cell) => cell.trim() !== '')
        );

        filteredData.forEach((row, index) => {
          if (Array.isArray(row) && row.length > 0) {
            if (fileType === 'shift') {
              if (validateShiftRow(row)) {
                validRows.push({ rowNumber: index + 1, row });
              } else {
                invalidRows.push({ rowNumber: index + 1, row });
              }
            } else if (fileType === 'event') {
              if (validateEventRow(row)) {
                validRows.push({ rowNumber: index + 1, row });
              } else {
                invalidRows.push({ rowNumber: index + 1, row });
              }
            }
          } else {
            invalidRows.push({ rowNumber: index + 1, row: row || [] });
          }
        });

        if (fileType === 'shift') {
          if (invalidRows.length) {
            toast.error(`Please upload valid file`);
            return;
          }
          handleShiftFileUpload(file);
        } else if (fileType === 'event') {
          if (invalidRows.length) {
            toast.error(`Please upload valid file`);
            return;
          }
          handleEventFileUpload(file);
        }
      },
      error: (error: any) => {
        toast.error(`Error parsing CSV`);
      },
    });
  };

  const isWithinLast30Minutes = isAssignedWithinLast120Minutes(
    period?.assignedAt
  );

  const { getRootProps: getShiftRootProps, getInputProps: getShiftInputProps } =
    useDropzone({
      accept: { 'text/csv': ['.csv'] },
      maxFiles: 1,
      onDrop: (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
          handleFileUpload(file, 'shift');
        }
      },
      onDropRejected: () => {
        toast.error('You can upload only one file at a time.', {
          position: 'bottom-right',
        });
      },
    });

  const { getRootProps: getEventRootProps, getInputProps: getEventInputProps } =
    useDropzone({
      accept: { 'text/csv': ['.csv'] },
      maxFiles: 1,
      onDrop: (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
          handleFileUpload(file, 'event');
          // handleEventFileUpload(file);
        }
      },
      onDropRejected: () => {
        toast.error('You can upload only one file at a time.', {
          position: 'bottom-right',
        });
      },
    });

  return (
    <>
      <TableRow
        key={period.id}
        sx={{
          backgroundColor: isWithinLast30Minutes ? 'lightblue' : 'inherit',
        }}
      >
        <TableCell
          align="left"
          sx={{
            visibility:
              (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
                !period.isRunning) ||
              (hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
                period?.statusTms === 'TAGGING_COMPLETED')
                ? 'hidden'
                : 'visible',
          }}
        >
          {period.token}
          <Tooltip title="Copy Period ID">
            <IconButton
              onClick={() => {
                navigator.clipboard.writeText(period.token);
              }}
              size="small"
              sx={{ marginLeft: 1 }} // Add margin for spacing
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell
          align="left"
          sx={{
            margin: '0',
            padding: '15px 0',
            whiteSpace: 'nowrap',
            visibility:
              hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
              !period.isRunning
                ? 'hidden'
                : 'table-cell',
          }}
        >
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 100 },
              margin: '0 !important',
              padding: '0 !important',
            }}
          >
            <Select
              // disabled={['ASSIGNED', 'UNASSIGNED', 'FINISHED'].includes(
              //   period?.statusTms
              // )}
              value={period.periodNo}
              onChange={(event) => updatePeriod(event, period.id)}
              sx={{
                border: 'none',
                outline: 'none',
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                '& .MuiSvgIcon-root': { marginRight: '8px' },
                color: '#61677A',
                backgroundColor: '#F4F6F8',
                borderRadius: '50px',
                height: '30px',
                paddingLeft: '10px',
              }}
              disabled={hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])}
              MenuProps={{ PaperProps: { sx: { maxHeight: 240 } } }}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {[1, 2, 3].map((period, ind) => (
                <MenuItem
                  key={ind}
                  value={period}
                  // sx={{ color: '#61677A', fontWeight: '800 !important' }}
                >
                  {period}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>
        <TableCell
          sx={{
            visibility:
              hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
              !period.isRunning
                ? 'hidden'
                : 'table-cell',
          }}
        >
          {period.gameId}
          <Tooltip title="Copy Game ID">
            <IconButton
              onClick={() => {
                navigator.clipboard.writeText(period.gameId);
              }}
              size="small"
              sx={{ marginLeft: 1 }} // Add margin for spacing
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell
          sx={
            {
              // visibility:
              //   ROLE_MAP[currentUserInfo.roleId] === 'tagger' &&
              //    !period.isRunning
              //     ? 'hidden'
              //     : 'table-cell',
            }
          }
        >
          {period?.assignedAt ? (
            <Stack direction={'column'}>
              <Typography variant="body2">
                {moment(period?.assignedAt).format(`${dateFormat}`)}
              </Typography>
              <Typography variant="body2">
                {moment(period?.assignedAt).format(`${timeFormat}`)}
              </Typography>
            </Stack>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell
          align="left"
          sx={
            {
              // visibility:
              //   ROLE_MAP[currentUserInfo.roleId] === 'tagger' &&
              //   !period.isRunning
              //     ? 'hidden'
              //     : 'table-cell',
            }
          }
        >
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 210 },
              margin: '0 !important',
              padding: '0 !important',
              // fontWeight: '600 !important',
            }}
          >
            <Autocomplete
              size="small"
              onClose={() => {
                const data = {
                  target: {
                    value: '',
                  },
                };
                handleSearchChangeTag(data);
              }}
              options={optionsTagger}
              id="disable-clearable"
              disabled={hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])}
              disableClearable
              value={value} // Pass the value as an object
              onChange={(e, newValue: any) => {
                assignChange(newValue, period.id, period.gameId);
                // Set the selected option as the value
              }}
              renderOption={(props: any, option: any) => {
                return (
                  <Box component="li" {...props} key={option?.id}>
                    <Typography
                      variant="body1"
                      sx={{ fontStyle: 'normal', textTransform: 'none' }}
                    >
                      {' '}
                      {UserPermissions[details.isDesabled]?.includes(
                        permissions.PARENTUSER
                      )
                        ? `${option?.label} (${option?.middleName})`
                        : option?.label}
                    </Typography>
                  </Box>
                );
              }}
              isOptionEqualToValue={(option, value) => option.id === value?.id} // Compare by id for selected item
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={debouncedQueryTag}
                  onChange={(e) => handleSearchChangeTag(e)}
                  variant="outlined"
                  slotProps={{
                    input: {
                      ...params.InputProps,
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </TableCell>

        {isPeriodOnly && (
          <TableCell
            align="left"
            sx={{
              visibility:
                hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
                !period.isRunning
                  ? 'hidden'
                  : 'table-cell',
            }}
          >
            {' '}
            <Tooltip title="Comments" placement="top" arrow>
              <IconButton
                onClick={() => {
                  commentView.onTrue();
                  popover.onClose();
                }}
              >
                <Iconify icon="majesticons:comment-text-line" />
              </IconButton>
            </Tooltip>
          </TableCell>
        )}
        <TableCell align="left">
          {' '}
          <Box>{formatElapsedTime(elapsedTime)}</Box>
        </TableCell>
        <TableCell
          align="left"
          sx={{ margin: '0', paddingLeft: '20px', whiteSpace: 'nowrap' }}
        >
          {isRunning ? (
            <Tooltip title="Stop" placement="top" arrow>
              <IconButton
                disabled
                // ={
                //   ['ASSIGNED', 'UNASSIGNED', 'FINISHED'].includes(
                //     period?.statusTms
                //   ) ||
                //   ROLE_MAP[currentUserInfo.roleId] === 'admin' ||
                //   ROLE_MAP[currentUserInfo.roleId] === 'moderator'
                // }
                onClick={() => {
                  confirm.onTrue();
                  popover.onClose();
                }}
                sx={{
                  cursor:
                    ['ASSIGNED', 'UNASSIGNED', 'FINISHED'].includes(
                      period?.statusTms
                    ) ||
                    hasRole(currentUserInfo.roleId, [
                      ROLE_IDS.ADMIN,
                      ROLE_IDS.MODERATOR,
                      ROLE_IDS.SUPER_ADMIN,
                    ])
                      ? 'not-allowed'
                      : 'pointer',
                }}
              >
                <Iconify
                  icon="ph:pause-fill"
                  style={{
                    color: !isRunning ? 'gray' : '#637381',
                    opacity:
                      ['ASSIGNED', 'UNASSIGNED', 'FINISHED'].includes(
                        period?.statusTms
                      ) ||
                      hasRole(currentUserInfo.roleId, [
                        ROLE_IDS.ADMIN,
                        ROLE_IDS.MODERATOR,
                        ROLE_IDS.SUPER_ADMIN,
                      ])
                        ? 0.5
                        : 1,
                  }}
                />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Start" placement="top" arrow>
              <IconButton
                disabled={
                  [
                    'ASSIGNED',
                    'UNASSIGNED',
                    'TAGGING_COMPLETED',
                    'FINISHED',
                  ].includes(period?.statusTms) ||
                  hasRole(currentUserInfo.roleId, [
                    ROLE_IDS.ADMIN,
                    ROLE_IDS.MODERATOR,
                    ROLE_IDS.SUPER_ADMIN,
                  ])
                }
                onClick={() => handleStart()}
                sx={{
                  cursor:
                    ['ASSIGNED', 'UNASSIGNED', 'FINISHED'].includes(
                      period?.statusTms
                    ) ||
                    hasRole(currentUserInfo.roleId, [
                      ROLE_IDS.ADMIN,
                      ROLE_IDS.MODERATOR,
                      ROLE_IDS.SUPER_ADMIN,
                    ])
                      ? 'not-allowed'
                      : 'pointer',
                }}
              >
                <Iconify
                  icon="ph:play-fill"
                  style={{
                    color: isRunning ? 'gray' : '#637381',
                    opacity:
                      ['ASSIGNED', 'UNASSIGNED', 'FINISHED'].includes(
                        period?.statusTms
                      ) ||
                      hasRole(currentUserInfo.roleId, [
                        ROLE_IDS.ADMIN,
                        ROLE_IDS.MODERATOR,
                        ROLE_IDS.SUPER_ADMIN,
                      ])
                        ? 0.5
                        : 1,
                  }}
                />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>

        <TableCell
          align="left"
          sx={{
            margin: '0',
            padding: '15px 0',
            whiteSpace: 'nowrap',
            visibility:
              hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
              !period.isRunning
                ? 'hidden'
                : 'table-cell',
          }}
        >
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 100 },
              margin: '0 !important',
              padding: '0 !important',
            }}
          >
            <Select
              disabled={hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])}
              value={
                period?.reviewRate && period.reviewRate.length > 0
                  ? period.reviewRate[period.reviewRate.length - 1].reviewRate
                  : 0
              }
              onChange={(event) =>
                updateReviewRate(event, period.id, period.gameId)
              }
              sx={{
                border: 'none',
                outline: 'none',
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                '& .MuiSvgIcon-root': { marginRight: '8px' },
                color: '#61677A',
                backgroundColor: '#F4F6F8',
                borderRadius: '50px',
                height: '30px',
                paddingLeft: '10px',
              }}
              MenuProps={{ PaperProps: { sx: { maxHeight: 240 } } }}
            >
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rate, ind) => (
                <MenuItem
                  key={ind}
                  value={rate}
                  // sx={{ color: '#61677A', fontWeight: '800 !important' }}
                >
                  {rate}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </TableCell>

        <TableCell
          align="left"
          sx={{
            visibility:
              hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
              !period.isRunning
                ? 'hidden'
                : 'table-cell',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {!hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) && (
              <LoadingButton
                color="primary"
                onClick={handleClickProgress}
                loading={loadingProgress}
                loadingPosition="start"
                startIcon={<RefreshIcon />}
                variant="text"
                sx={{ textTransform: 'none', ml: 2 }}
              ></LoadingButton>
            )}
            {/* Progress Details */}
            {period?.progressDetails?.length > 0 ? (
              <Box>
                {period.progressDetails.map((detail: any, index: any) => (
                  <Typography key={index}>
                    <span style={{ fontWeight: 'bold' }}>
                      {detail?.name?.charAt(0) || ''}
                    </span>
                    &nbsp;&nbsp;
                    <span>
                      {dayjs(detail?.elapsedTime).format('DD/MM/YYYY HH:mm') ||
                        0}
                    </span>
                    &nbsp;&nbsp;
                    <span>{detail?.eventTime || 0}</span>
                  </Typography>
                ))}
              </Box>
            ) : (
              <Typography></Typography>
            )}

            {/* Loading Button */}
          </Box>
        </TableCell>

        {/* <TableCell>
          <Button
            onClick={() => changeStatus(period.id, period.gameId)}
            variant="contained"
            disabled={loading} // Disable the button while loading
            startIcon={loading ? <CircularProgress size={20} /> : null} // Show loader if loading
          >
            {loading ? 'Loading...' : 'COMPLATED'}
          </Button>
        </TableCell> */}
        <TableCell
          align="left"
          sx={{
            margin: '0',
            padding: '15px 0',
            whiteSpace: 'nowrap',
            // visibility:
            //   ROLE_MAP[currentUserInfo.roleId] === 'tagger' &&
            //   !period.isRunning
            //     ? 'hidden'
            //     : 'table-cell',
          }}
        >
          <FormControl
            sx={{
              flexShrink: 0,
              width: { xs: 1, md: 150 },
              margin: '0 !important',
              padding: '0 !important',
            }}
          >
            <Tooltip title={period?.statusTms} arrow placement="top">
              <Select
                disabled={hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER])}
                value={period?.statusTms ? period?.statusTms : ''}
                onChange={(event) =>
                  updateStatus(event, period.id, period.gameId)
                }
                sx={{
                  color: '#61677A',
                  backgroundColor: '#C4CDD5',
                  borderRadius: '50px',
                  height: '30px',
                  paddingLeft: '5px',
                  fontSize: '13px',
                  '& .MuiSvgIcon-root': {
                    color: '#61677A',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: { maxHeight: 240 },
                  },
                }}
              >
                {PERIOD_STATUS.map((status, ind) => (
                  <MenuItem
                    key={ind}
                    value={status}
                    disabled={handleCheckDisable(
                      period?.statusTms,
                      status,
                      currentUserInfo.role
                    )}
                    sx={{
                      color: '#61677A',
                    }}
                  >
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </Tooltip>
          </FormControl>
        </TableCell>
        <TableCell
          sx={{
            visibility:
              hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
              !period.isRunning
                ? 'hidden'
                : 'table-cell',
          }}
        >
          <Tooltip title="Upload File" arrow placement="top">
            <IconButton
              onClick={() => {
                uplaodFile.onTrue();
                popover.onClose();
              }} // Open the dialog
              size="small"
            >
              <CloudUploadIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View Files" arrow placement="top">
            <IconButton
              sx={{
                color: period.documents.length > 0 ? '#1976D2' : 'default',
              }}
              onClick={() => {
                viewFile.onTrue();
                popover.onClose();
                fetchDocumentsByPeriodAndType;
              }} // Open the dialog
              size="small"
            >
              <Iconify icon="carbon:view-filled" />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell
          sx={{
            visibility:
              hasRole(currentUserInfo.roleId, [ROLE_IDS.TAGGER]) &&
              !period.isRunning
                ? 'hidden'
                : 'table-cell',
          }}
        >
          <LoadingButton
            variant="contained"
            sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}
            disabled={
              hasRole(currentUserInfo.roleId, [
                ROLE_IDS.ADMIN,
                ROLE_IDS.MODERATOR,
                ROLE_IDS.SUPER_ADMIN,
              ]) ||
              !(
                (
                  period?.documents?.some((doc: any) => doc.type === 1) && // Ensure at least one file of type 1
                  period?.documents?.some((doc: any) => doc.type === 2)
                ) // Ensure at least one file of type 2
              )
            }
            color="primary"
            size="small"
            loading={isLoadingCompleteStatus}
            startIcon={<ChecklistIcon fontSize="small" />}
            onClick={() => ChangeStatus(period.id, period.gameId)}
          >
            Completed
          </LoadingButton>
        </TableCell>
      </TableRow>

      <CommentDialog
        open={viewFile.value}
        onClose={viewFile.onFalse}
        fullWidth={true}
        maxWidth={'xl'}
        sx={{ width: '100%' }}
        title="View File"
        content={
          <>
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Shift" />
              <Tab label="Event" />
            </Tabs>
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Game ID</TableCell>
                    <TableCell>Period ID</TableCell>
                    <TableCell>Updated By</TableCell>
                    <TableCell>Updated At</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {viewFileData.map((data: any) => (
                    <React.Fragment key={data.id}>
                      {' '}
                      {/* Use data.id as the key */}
                      <TableRow>
                        <TableCell>{data?.gameId}</TableCell>
                        <TableCell>{data?.periodId}</TableCell>
                        <TableCell>{data?.user?.name}</TableCell>
                        <TableCell>
                          {/* {moment(data.updatedAt).format(
                            `${dateFormat} hh:mm a`
                          )} */}
                          {data.updatedAt ? (
                            <Stack direction={'column'}>
                              <Typography variant="body2">
                                {moment(data.updatedAt).format(`${dateFormat}`)}
                              </Typography>
                              <Typography variant="body2">
                                {moment(data.updatedAt).format(`${timeFormat}`)}
                              </Typography>
                            </Stack>
                          ) : (
                            '-'
                          )}
                        </TableCell>

                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 2 }}>
                            <IconButton
                              onClick={() => handleRowToggle(data?.id)} // Use data.id for toggling
                            >
                              <ExpandMoreIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                      {/* Expandable Row for Files */}
                      {expandedRows[data?.id] && ( // Check expanded state using data.id
                        <TableRow>
                          <TableCell colSpan={6}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Version</TableCell>
                                  <TableCell>File Name</TableCell>
                                  <TableCell>Created By</TableCell>
                                  <TableCell>Date</TableCell>
                                  <TableCell>Download</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {Array.isArray(data?.files) &&
                                data?.files.length > 0 ? (
                                  data?.files
                                    .sort((a: any, b: any) =>
                                      a.createdAt < b.createdAt ? 1 : -1
                                    )
                                    .map((file: any, index: any) => (
                                      <TableRow key={index}>
                                        <TableCell>
                                          {data?.files?.length - index}
                                        </TableCell>
                                        <TableCell>
                                          {file?.Key?.split('/').splice(-1)}
                                        </TableCell>
                                        <TableCell>
                                          {file?.documentOfUser?.name}
                                        </TableCell>
                                        <TableCell>
                                          {/* {moment(file.createdAt).format(
                                            `${dateFormat} hh:mm a`
                                          )} */}
                                          {file.createdAt ? (
                                            <Stack direction={'column'}>
                                              <Typography variant="body2">
                                                {moment(file.createdAt).format(
                                                  `${dateFormat}`
                                                )}
                                              </Typography>
                                              <Typography variant="body2">
                                                {moment(file.createdAt).format(
                                                  `${timeFormat}`
                                                )}
                                              </Typography>
                                            </Stack>
                                          ) : (
                                            '-'
                                          )}
                                        </TableCell>
                                        <TableCell>
                                          <IconButton
                                            component="a"
                                            href={file?.Url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                          >
                                            <GetAppIcon />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={6} align="center">
                                      No files available
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        }
        action={
          <Button
            variant="contained"
            color="success"
            size="small" // Make the button smaller
            onClick={() => {
              viewFile.onFalse(); // Close the dialog
            }}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Close
          </Button>
        }
      />

      <CommentDialog
        open={uplaodFile.value}
        onClose={uplaodFile.onFalse}
        title="Upload File"
        content={
          <>
            <Box display="flex" flexDirection="column" gap={2}>
              {/* Drag and drop for shift file */}
              <Box
                {...getShiftRootProps()}
                sx={{
                  border: '2px dashed gray',
                  borderRadius: 2,
                  padding: 2,
                  textAlign: 'center',
                  cursor: 'pointer',
                  height: '180px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <input
                  {...getShiftInputProps()}
                  style={{
                    display: 'none',
                  }}
                />
                {isLoadingShiftFile ? (
                  <CircularProgress size={24} />
                ) : (
                  <>
                    <CloudUploadIcon />
                    <Typography variant="body2">
                      Drag & Drop or Click to Upload <strong>Shift File</strong>
                    </Typography>
                  </>
                )}
              </Box>

              {/* Drag and drop for event file */}
              <Box
                {...getEventRootProps()}
                sx={{
                  border: '2px dashed gray',
                  borderRadius: 2,
                  padding: 2,
                  textAlign: 'center',
                  cursor: 'pointer',
                  height: '180px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <input {...getEventInputProps()} style={{ display: 'none' }} />
                {isLoadingEventFile ? (
                  <CircularProgress size={24} />
                ) : (
                  <>
                    <CloudUploadIcon />
                    <Typography variant="body2">
                      Drag & Drop or Click to Upload <strong>Event File</strong>
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </>
        }
        action={
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={() => {
              uplaodFile.onFalse();
            }}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Close
          </Button>
        }
      />

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Stop Timer!!"
        content="Are You Sure to Stop Timer?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              // onStatusChange(selectedValue);
              handleStop();
              confirm.onFalse();
            }}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Stop
          </Button>
        }
      />

      <CommentBox
        data={period}
        comment={commentView}
        gameData={gameData}
        commentText={commentText}
        setCommentText={setCommentText}
        addComment={addComment}
      />
    </>
  );
}

export default PeriodRow;
